import React from 'react';
import { css, styled } from 'styled-components';
import { ProcessStartWizardCol } from '../ProcessStartWizardCol';

export function ProcessStartWizardRowBody(props: {
    children: React.ReactNode[];
    hasAction?: boolean;
    result?: boolean;
    wrapChildren?: boolean;
}) {
    return (
        <StyledProcessStartWizardRowBody $hasAction={props.hasAction}>
            <StyledRow $result={props.result}>
                {handleChildren(props.children, props.wrapChildren, props.result)}
            </StyledRow>
        </StyledProcessStartWizardRowBody>
    );
}

function handleChildren(children: React.ReactNode[], wrapChildren?: boolean, result?: boolean) {
    return wrapChildren
        ? children.map((child, i) => (
              <ProcessStartWizardCol
                  key={i}
                  result={result}
              >
                  {child}
              </ProcessStartWizardCol>
          ))
        : children;
}

const StyledProcessStartWizardRowBody = styled.div<{ $hasAction?: boolean }>`
    order: 3;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;

    ${({ theme }) => theme.mediaQueries.small} {
        order: 2;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .btn {
        margin-bottom: 0.625rem;
        margin-right: 10px;
    }

    ${({ $hasAction }) =>
        $hasAction &&
        css`
            ${({ theme }) => theme.mediaQueries.small} {
                flex: 0 0 58.3333%;
                max-width: 58.3333%;
            }
        `}
`;

const StyledRow = styled.div<{ $result?: boolean }>`
    display: flex;
    flex-wrap: wrap;

    ${({ $result }) =>
        $result &&
        css`
            margin-right: -5px;
            margin-left: -5px;
        `}
`;
